import React, { useState } from "react";
import { connect } from "react-redux";
import { loadArticles } from "../../../modules/articles";
import { renderArticleImage } from "../../../pages/Home/NewsArticle";
import useCmsContent from "../../../hooks/useCmsContent";
import { Link } from "react-router-dom";
import { ButtonPrimary, ButtonTertiary } from "../../Button";
import { convertToWords, htmlExcerpt } from "../../../modules/string-tools";
import * as NEWS_ROUTES from "../../../Router/news_routes";
import { token } from "../../../modules/auth";
import useAxios from "../../../hooks/useAxios";

const ArticleSegment = ({ item }) => {
  return (
    <Link to={{ pathname: item.link }} className="block">
      <div className="flex text-black items-start py-4 border-b border-light-grey">
        <div className="w-24 h-24 mr-4 flex-shrink-0 border border-grey-md">
          <span className="text-sm flex items-center justify-center h-full">
            {renderArticleImage(item.img, false)}
          </span>
        </div>
        <div className="flex flex-col justify-between pr-12">
          <h4
            className="font-bold text-lg mb-2"
            dangerouslySetInnerHTML={{ __html: item.title }}
          />
          <div className="mt-2 text-xs">
            <div
              dangerouslySetInnerHTML={{
                __html: htmlExcerpt(item.content, 100),
              }}
            />{" "}
            <p className="mt-2 font-bold underline uppercase text-xs text-black">
              Read more
            </p>
          </div>
        </div>
      </div>
    </Link>
  );
};

const AgencyDashFeed = ({
  newsletterLink,
  newsletterTitle,
  newsletterPanelTitle,
}) => {
  const content = useCmsContent(4, "created_at");
  const { data: commissionOfferData } = useAxios(
    {
      url: window.API + "/cms/offers",
      params: { orderBy:"created_at", 'type': 'commission-offers' },
    },
    true,
    false,
    4
    // !offers.length
  );

  const { data: specialOffersData } = useAxios(
    {
      url: window.API + "/cms/offers",
      params: { orderBy:"created_at", 'type': 'special-offers' },
    },
    true,
    false,
    4
    // !offers.length
  );



  const sections = [
    {
      key: "commissionOffers",
      label: "Commission Offers",
      route: NEWS_ROUTES.FRONTEND.COMMISSION_OFFERS,
      nothingFound: "No current commission offers are available",
    },
    {
      key: "news",
      label: "Venue News",
      route: NEWS_ROUTES.FRONTEND.VENUE_NEWS,
      nothingFound: "No venue news found",
    },
    {
      key: "specialOffers",
      label: "Special Offers",
      route: NEWS_ROUTES.FRONTEND.SPECIAL_OFFERS,
      nothingFound: "No special offers found",
    },
    // { key: "famTrips", label: "FAM Trips", route: NEWS_ROUTES.FRONTEND.FAM_TRIPS, nothingFound: "No current FAM Trips are available" },
    // { key: "moversAndShakers", label: "Movers and Shakers", route: NEWS_ROUTES.FRONTEND.MOVERS_AND_SHAKERS, nothingFound: "No current offers are available" },
  ];

  const [openKey, setOpenKey] = useState();

  const handleToggle = key => {
    setOpenKey(prevKey => (prevKey === key ? null : key));
  };
  return (
    <div key={`agencyNewsFeed`} className={"mt-6"}>
      {newsletterLink && newsletterTitle && (
        <div className={"flex flex-col bg-grey p-4"}>
          <div className="flex">
            <div className={"flex-1 pr-4"}>
              <p className={"mb-4 text-base"}>{newsletterPanelTitle}</p>
              <h3 className={"text-bold text-xl"}>{newsletterTitle}</h3>
              <div className="my-2 mt-4">
                <a
                  href={newsletterLink}
                  target={"_blank"}
                  rel={"noreferrer nofollow"}
                >
                  <ButtonPrimary classes={"max-w-full"}>
                    Read more
                  </ButtonPrimary>
                </a>
              </div>
            </div>
            <img src={"/img/agency-dash-newsletter-thumbnail.png"} />
          </div>
        </div>
      )}

      {sections.map(({ key, label, route, nothingFound }) => (
        <div key={key} className="border-b border-grey">
          <div
            className="flex justify-between items-center cursor-pointer py-6"
            onClick={() => handleToggle(key)}
          >
            <h3 className="text-lg font-bold">{label}</h3>
            <span className="text-xl font-bold">
              {openKey === key ? "−" : "+"}
            </span>
          </div>

          {openKey === key && (
            <div
              className={`accordion-content transition-max-height duration-500 ease-in-out overflow-hidden ${
                openKey === key ? "max-h-screen" : "max-h-0"
              }`}
            >
              {key === 'commissionOffers' && commissionOfferData.length > 0 ? (
                <>
                  {commissionOfferData.slice(0, 3).map((item, index) => (
                    <ArticleSegment key={index} item={item} />
                  ))}
                </>
              ) : (
                key === 'commissionOffers' ?
                <div
                  className={
                    "w-full text-center inline-block bg-blue text-white p-4 mt-2 text-lg"
                  }
                >
                  <span>{nothingFound}</span>
                </div> : <></>
              )}
              {key === 'specialOffers' && specialOffersData && specialOffersData.length > 0 ? (
                <>
                  {specialOffersData.slice(0, 3).map((item, index) => (
                    <ArticleSegment key={index} item={item} />
                  ))}
                </>
              ) : (
                key === 'specialOffers' ?
                <div
                  className={
                    "w-full text-center inline-block bg-blue text-white p-4 mt-2 text-lg"
                  }
                >
                  <span>{nothingFound}</span>
                </div> : <></>
              )}

              {key !== 'specialOffers' && key !== 'commissionOffers' && content[key] && content[key].length > 0 ? (
                <>
                  {content[key].slice(0, 3).map((item, index) => (
                    <ArticleSegment key={index} item={item} />
                  ))}
                </>
              ) : (
                key !== 'specialOffers' && key !== 'commissionOffers' ?
                <div
                  className={
                    "w-full text-center inline-block bg-blue text-white p-4 mt-2 text-lg"
                  }
                >
                  <span>{nothingFound}</span>
                </div> : <></>
              )}
              <div className="mb-8 mt-4">
                <ButtonTertiary
                  style={{ width: "inherit" }}
                  classes="text-md font-bold"
                >
                  <Link to={route} className="text-white">
                    View all {label}
                  </Link>
                </ButtonTertiary>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default connect(
  state => ({
    token: token(state),
    articles: state.articles.articles,
    offers: state.articles.offers,
    articlesLoaded: state.articles.loaded,
    articlesLoading: state.articles.loading,
  }),
  { loadArticles }
)(AgencyDashFeed);
